import { RootState, FetchRequestState } from 'types'
type State = RootState['reviewsFetchRequests']

export default function reduce(state: State = FetchRequestState.Idle, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_REVIEWS_FETCH_REQUEST': {
      return payload.state
    }
    default:
      return state
  }
}
